import React from 'react';
import MentorMatchMedtronicCommon from '../common';

export default function MentorMatchDrBroderick({
  home,
  updateAnswersAction,
  setPatientPartnerQuestionnaireProgress,
  setContactIdAction,
  setPatientPartners,
}) {
  return (
    <MentorMatchMedtronicCommon
      home={home}
      updateAnswersAction={updateAnswersAction}
      setPatientPartnerQuestionnaireProgress={setPatientPartnerQuestionnaireProgress}
      setContactIdAction={setContactIdAction}
      setPatientPartners={setPatientPartners}
      surgeonId={gon.dr_broderick_surgeon_id}
    />
  );
}
